import * as React from 'react';

export function withClassOnFirstTab<P>(notFirstTab:boolean = false) {

  return (WrappedComponent: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>) => {

    return (props) => {
      const {
        firstSection,
        expandAll,
        activeSection
      } = props as any;

      const modifiedProps: any = { ...props as any };

      if ((expandAll || (activeSection && firstSection && activeSection === firstSection)) !== notFirstTab) {
        modifiedProps.className = !notFirstTab ? 'first-tab' : 'not-first-tab';
      }

      return <WrappedComponent { ...modifiedProps } /> ;
    };
  };
}
